export enum Ethnicities {
  'Hispanic' = 'Hispanic',
  'NonHispanic' = 'Non-Hispanic',
  'Unknown' = 'Unknown',
}
